import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  private translations = {
    'presumptive': 'presuntivo',
    'definitive': 'definitivo',
    // Add more mappings as necessary
  };

  private regex: RegExp | null = null;  // Cache for the regex pattern

  // Method to generate and cache the regex
  private generateRegex(): RegExp {
    const pattern = Object.keys(this.translations).join('|');
    return new RegExp(`\\b(${pattern})\\b`, 'gi');
  }

  // Method to translate a sentence
  translateSentence(sentence: string | null | undefined): string {
    // Check if the sentence is null or undefined and return an empty string or the original sentence
    if (!sentence) {
      return ''; // Or return sentence if you'd prefer to return null or undefined.
    }

    if (!this.regex) {
      this.regex = this.generateRegex();  // Cache the regex once
    }

    // Perform the replacement only if sentence is a valid string
    return sentence.replace(this.regex, (match) => {
      const lowerMatch = match.toLowerCase();
      return this.translations[lowerMatch] || match;
    });
  }

  // Method to add new translations to the dictionary
  addTranslation(english: string, spanish: string): void {
    this.translations[english.toLowerCase()] = spanish;
    this.regex = null;  // Reset the cached regex when the dictionary is updated
  }
}